var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#007FCF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.707 11.6414L16.3418 21.0586L13.5 18.2105L22.8793 8.79649C22.9714 8.7036 23.0809 8.62977 23.2016 8.57922C23.3222 8.52867 23.4516 8.50239 23.5825 8.50189C23.7133 8.50138 23.8429 8.52665 23.9639 8.57626C24.085 8.62587 24.1951 8.69885 24.2879 8.79102L24.2934 8.79649L25.707 10.2188C25.8947 10.4079 25.9999 10.6636 25.9999 10.9301C25.9999 11.1965 25.8947 11.4522 25.707 11.6414V11.6414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3387 21.0621L14.2071 23.2055C14.021 23.393 13.7681 23.4989 13.5039 23.4999C13.2397 23.5009 12.986 23.397 12.7985 23.2109L12.793 23.2055L6.293 16.668C6.10529 16.4789 5.99995 16.2233 5.99995 15.9568C5.99995 15.6904 6.10529 15.4348 6.293 15.2457L7.70706 13.8234C7.89283 13.6364 8.14519 13.5307 8.40881 13.5294C8.67243 13.5282 8.92578 13.6315 9.11331 13.8168L9.11956 13.8234L16.3387 21.0621Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckRound);
export default __webpack_public_path__ + "static/media/IconCheckRound.8fe2f4ce.svg";
export { ForwardRef as ReactComponent };